import React from 'react';
import { Navigate } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { SignIn, Show, PricingTable } from "@clerk/react";
import usePaidPlan from '../hooks/usePaidPlan';
import './Profile.css';

function Subscribe() {
  const { hasPaidPlan } = usePaidPlan();

  return (
    <>
      <Header />
      <Show when="signed-out">
        <div className="dashboard-container">
          <div className="dashboard-placeholder">
            <SignIn forceRedirectUrl="/subscribe" />
          </div>
        </div>
      </Show>
      <Show when="signed-in">
        {hasPaidPlan ? (
          <Navigate to="/" replace />
        ) : (
          <div className="dashboard-container">
            <div className="dashboard-placeholder">
              <h1 className="dashboard-title">Subscribe to unlock Bidder iQ</h1>
              <PricingTable />
            </div>
          </div>
        )}
      </Show>
      <Footer />
    </>
  );
}

export default Subscribe;
